export const mappedLocales = {
  uk: 'en-GB',
  fr: 'fr-FR',
  es: 'es-ES',
  de: 'de-DE',
} as const;

export type MappedLocales = typeof mappedLocales;
export type MappedLocale = MappedLocales[keyof MappedLocales];
